import { IParameterizable } from '../../interfaces/IParameterizable';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { A365Named } from '../base/a365Named';
import { Collection, IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Owned } from '../base/named';
import { OwnedSet } from '../base/ownedset';
import { Parameter } from '../base/parameter';
import { Folder } from '../folder/folder';
import { LinkedService } from '../linkedservice/linkedservice';
import { ModelConstants } from '../model-constants';
import { ITable } from '../table/interface';
import { IMappingArtifactSource } from './IMappingArtifactSource';
import { MappingDirective } from './mappingdirective';
import { IRelationship } from '../relationship/interface';
import { validateMappingDirectives } from './mappingartifact-validation.util';

/* Things the ETL Mapping entity needs to keep track of:
Sources[] - all the source tables that are available for mapping in each target table
Sink[] - all of the target tables that will be mapped to

MappingDirectives: MappingDirective[] - each target table should have a MappingDirective

MappingDirective {
    targetEntityReference - name of the target table
    sourceEntityReferences[] - names of the source tables used in the mapping
    sourceDenormalizeInfo - I think this is for the joins and things to create a new source. Still a bit unclear
    attributeMappingInfo - an object with a field called attributeMappings: AttributeMapping[] which stores the info for a given column about how it is being mapped from the source to the target
}
*/

// TODO: Remove mapping artifact
@Metamodel.model({
    name: ModelConstants.mappingArtifact,
    display: [shellStringResources.MappingArtifact, shellStringResources.MappingArtifacts],
    reusable: true,
    referable: true,
    validator: MappingArtifact.prototype.validate
})
export class MappingArtifact extends A365Named implements IParameterizable {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: Parameter.MODEL,
        collection: Collection.Set,
        constraint: {
            unique: true
        }
    })
    public readonly parameters = OwnedSet.create<Parameter>(this);

    public folder: Folder = Owned.create(Folder.MODEL, this);

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL
    })
    public sourceLinkedService: LinkedService;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL
    })
    public targetLinkedService: LinkedService;

    public sourceTables: ITable[] = [];
    public sourceDatasets: IMappingArtifactSource[] = [];

    public targetTables: ITable[] = [];

    public targetRelationships: IRelationship[] = [];

    public mappingDirectives: MappingDirective[] = [];

    constructor(name?: string, description?: string) {
        super(name, description, null);
        this.resourceType = ModelConstants.mappingArtifact + 's';
    }

    public validate(): IViolation[] | undefined {
        const violations: IViolation[] = [];
        const containsValidMappingDirectives = this.mappingDirectives.some((directive) => {
            return directive.attributeMappingInfo.length > 0;
        });

        if (!containsValidMappingDirectives) {
            violations.push({
                message: () => `${shellStringResources.InvalidMappings}.`
            });

            return violations;
        }

        this.mappingDirectives.forEach((mappingDirective) => {
            const mappingViolations = validateMappingDirectives(mappingDirective);
            Array.prototype.push.apply(violations, mappingViolations);
        });

        return violations;
    }
}
